export default __webpack_public_path__ + "static/media/question_07.1aa5c0bb.png";